import { AbstractControl, ValidatorFn } from '@angular/forms';

export function TodayDateValidator(): ValidatorFn {  
  return (control: AbstractControl): { [key: string]: any } | null => {
    let today : Date = new Date();
    let todayDateString = new Date(today.getFullYear(), new Date().getMonth(), today.getDate());
    if (new Date(control.value) < todayDateString)
      return { "MoreThanToday": true };
    return null;
  }
}

export function dateValidation(quotationDate:any,deadlineDate:any): ValidatorFn{
    return (control: AbstractControl): { [key: string]: any } | null =>{
      if (deadlineDate && quotationDate && (new Date(deadlineDate) > new Date(quotationDate))){
        return {"LessThanDeadlineDate": true};
      }
      return null;
    }
}